import script from "./ModalConfirm.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalConfirm.vue?vue&type=script&setup=true&lang=js"

import "./ModalConfirm.vue?vue&type=style&index=0&id=0643d220&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0643d220"]])

export default __exports__